import { render } from "./AppLoader.vue?vue&type=template&id=1d468165"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=1d468165&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__